var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.$route.params.subClassifierId !== '44' &&
      _vm.$route.params.subClassifierId !== '24'
    )?_c('generic-sub-classifier'):(_vm.$route.params.subClassifierId === '44')?_c('economic-activity-sub-classifier'):(_vm.$route.params.subClassifierId === '24')?_c('areas-sub-classifier'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }